import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

type HttpErrorStatusBarEvent = {
  message: string;
  route: string;
};

@Injectable({ providedIn: 'root' })
export class HttpErrorStatusBarService {
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly errorSubject = new ReplaySubject<HttpErrorStatusBarEvent>(1);

  public readonly error$ = this.errorSubject.asObservable();

  /**
   * Reports a generic API error to be displayed in the HTTP error status bar.
   * Idea is to translate errors/codes coming from the API in future.
   */
  public reportGenericError(): void {
    this.errorSubject.next({
      message: this.translateService.instant('COMMON.ERRORS.API.GENERIC_ERROR'),
      route: this.router.url,
    });
  }

  public clear(): void {
    this.errorSubject.next({ message: '', route: '' });
  }
}
